import { updateCompanyDomainApi, updateCompanyStatusApi } from "./CompanyService";

export const API_ENDPOINT = {
  Login: {
    api: "/superAdmin-api/v1/login",
    method: "POST",
  },
  Otp: {
    api: "/superAdmin-api/v1/verifyOTP",
    method: "POST",
  },
  Company: {
    api: "/superAdmin-api/v1/on-boarding",
    onboardingDetails: "/superAdmin-api/v1/details",
    updateCompanyDomainApi:"/superAdmin-api/v1/company/domain",
    updateCompanyStatusApi:"/superAdmin-api/v1/company/status"
  },
  ServiceCity: {
    api: "/superAdmin-api/v1/service-cities",
    City: "/company/v1/city",
    serviceRegion: "/trip-api/v1/service-regions",
    subVendorRegion: "/admin-api/v1/subvendor-serviceable-regions",
  },

  ChooseYourService: {
    api: "/trip-api/v1/trip-services",
  },
  Logout:{
    api:"/superAdmin-api/v1/logout"
  },
};
